import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { BehaviorSubject, map } from 'rxjs';
import { gateNexusSubscription } from '@nsc/nexus-permissions/nexus-api/nexus-permission-gate.js';
import { NexusPermission } from '@nsc/nexus-permissions/platform-rbac/nexus-permissions.js';
import {
  PartnerSchedulingImportRun,
  PartnerSchedulingImportRunStatus,
} from '../entities/PartnerSchedulingImportRun.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';

export interface ImportStatusState {
  status: PartnerSchedulingImportRunStatus;
  messages: string[];
}

export const importStatus$ = new BehaviorSubject<ImportStatusState>({
  status: PartnerSchedulingImportRunStatus.SUCCESS,
  messages: [],
});

// Seed from DB on module load
(async () => {
  try {
    const collection = await getRawCollection<PartnerSchedulingImportRun>(PartnerSchedulingImportRun._collectionName);
    const run = await collection.findOne({}, { sort: { importedAt: -1 } });
    if (run) {
      importStatus$.next({
        status: run.status ?? PartnerSchedulingImportRunStatus.SUCCESS,
        messages: run.messages ?? [],
      });
    }
  } catch (err) {
    // Ignore seeding errors
  }
})();

export function updateImportStatus(state: ImportStatusState) {
  importStatus$.next(state);
}

export const subscribeImportStatus = registerSubscription({
  operationName: 'subscribeImportStatus',
  type: () => [String],
  resolve: () => () =>
    gateNexusSubscription(NexusPermission.PartnerSchedulingImport, () =>
      importStatus$.asObservable().pipe(map(state => [state.status, ...state.messages])),
    ),
});
